var UPAccount = function UPAccount(address, email, newborn, message, signature) {
  this.address = address;
  this.email = email;
  this.newborn = newborn;
  this.message = message;
  this.signature = signature;
};
// ---------- AUTHORIZE ----------
var UPEventType;
(function (UPEventType) {
  UPEventType["REGISTER"] = "register";
})(UPEventType || (UPEventType = {}));
var UPEvent = function UPEvent(type, body) {
  this.type = type;
  this.body = body;
};
var UPAuthMessage = function UPAuthMessage(from, msg, type, isEIP191Prefix, onAuthChain) {
  this.from = from;
  this.msg = msg;
  this.type = type;
  this.isEIP191Prefix = isEIP191Prefix;
  this.onAuthChain = onAuthChain;
};
var UPTransactionMessage = function UPTransactionMessage(from, to, value, data) {
  this.from = from;
  this.to = to;
  this.value = value;
  this.data = data;
};
var UPResponse = function UPResponse(type, data) {
  this.type = type;
  this.data = data;
};
var UPMessage = function UPMessage(type, payload, appSetting) {
  this.type = type;
  this.payload = payload;
  this.appSetting = appSetting;
};
// ------------ CONNECT ------------
var UniPassTheme;
(function (UniPassTheme) {
  UniPassTheme["LIGHT"] = "light";
  UniPassTheme["DARK"] = "dark";
})(UniPassTheme || (UniPassTheme = {}));

export { UPAccount, UPAuthMessage, UPEvent, UPEventType, UPMessage, UPResponse, UPTransactionMessage, UniPassTheme };
//# sourceMappingURL=popup-types.esm.js.map
